import { FormattedRowParams } from '@qrios/frontend-library';

import {
  QueryType,
  UssdSessionCloseReason,
  UssdSessionCloseReasonQuery,
  VoiceSessionCloseReasonQuery,
  WapSessionCloseReason,
  WapSessionCloseReasonQuery
} from '../../../../api/interfaces';
import queryTypesMapper from '../../../../constants/queryTypes';
import operationTypesMapper from '../../../../constants/operationTypes';
import queryTypesMapperToString from '../../../../constants/queryTypesToString';
import wapSessionCloseReasonsToString from '../../../../constants/wapSessionCloseReasonsToString';
import wapSessionCloseReasonMapper from '../../../../constants/wapSessionCloseReasons';
import wapSessionCloseReasonsQueryToString from '../../../../constants/wapSessionCloseReasonsQueryToString';
import wapSessionCloseReasonQueryMapper from '../../../../constants/wapSessionCloseReasonsQuery';
import ussdSessionCloseReasonsToString from '../../../../constants/ussdSessionCloseReasonsToString';
import ussdSessionCloseReasonMapper from '../../../../constants/ussdSessionCloseReasons';
import ussdSessionCloseReasonsQueryToString from '../../../../constants/ussdSessionCloseReasonsQueryToString';
import ussdSessionCloseReasonQueryMapper from '../../../../constants/ussdSessionCloseReasonsQuery';
import voiceSessionCloseReasonQueryMapper from '../../../../constants/voiceSessionCloseReasonsQuery';
import voiceSessionCloseReasonsQueryToString from '../../../../constants/voiceSessionCloseReasonsQueryToString';

export const operationTypeFormatter = ({ value }: FormattedRowParams) => operationTypesMapper(value as string);

export const operationColumnQueryTypeFormatter = ({ value }: FormattedRowParams) =>
  operationTypesMapper(value as string);

export const convertQueryTypeToRedableFormat = (queryType: QueryType) => queryTypesMapperToString(queryType as string);

export const convertRedableFormatToQueryType = (queryType: string) => queryTypesMapper(queryType as QueryType);

export const convertWapSessionCloseReasonToReadableFormat = (reason: WapSessionCloseReason) =>
  wapSessionCloseReasonsToString(reason as string);

export const convertReadableToWapSessionCloseReason = (reason: string) =>
  wapSessionCloseReasonMapper(reason as WapSessionCloseReason);

export const convertWapSessionCloseReasonQueryToReadableFormat = (reason: WapSessionCloseReasonQuery) =>
  wapSessionCloseReasonsQueryToString(reason as string);

export const convertReadableToWapSessionCloseReasonQuery = (reason: string) =>
  wapSessionCloseReasonQueryMapper(reason as WapSessionCloseReasonQuery);

export const convertVoiceSessionCloseReasonQueryToReadableFormat = (reason: VoiceSessionCloseReasonQuery) =>
  voiceSessionCloseReasonsQueryToString(reason as string);

export const convertReadableToVoiceSessionCloseReasonQuery = (reason: string) =>
  voiceSessionCloseReasonQueryMapper(reason as VoiceSessionCloseReasonQuery);

export const convertUssdSessionCloseReasonToReadableFormat = (reason: UssdSessionCloseReason) =>
  ussdSessionCloseReasonsToString(reason as string);

export const convertReadableToUssdSessionCloseReason = (reason: string) =>
  ussdSessionCloseReasonMapper(reason as UssdSessionCloseReason);

export const convertUssdSessionCloseReasonQueryToReadableFormat = (reason: UssdSessionCloseReasonQuery) =>
  ussdSessionCloseReasonsQueryToString(reason as string);

export const convertReadableToUssdSessionCloseReasonQuery = (reason: string) =>
  ussdSessionCloseReasonQueryMapper(reason as UssdSessionCloseReasonQuery);
